import apiFetch from '../apiFetch'

export default function (body, token) {
  return apiFetch({ endPoint: 'FinanceCompany/Create', method: 'POST', body: body, token: token })
}
